import ace from "ace-builds";

ace.define(
  "ace/mode/volcanicLiquid",
  ["require", "exports", "ace/lib/oop", "ace/mode/liquid", "ace/mode/volcanicLiquid_highlight_rules"],
  (acequire, exports) => {
    const oop = acequire("ace/lib/oop");
    const LiquidMode = acequire("ace/mode/liquid").Mode;
    window.LiquidMode = LiquidMode;
    const CustomHighlightRules = acequire("ace/mode/volcanicLiquid_highlight_rules").CustomHighlightRules;
    let Mode = function() {
      LiquidMode.call(this);
      this.HighlightRules = CustomHighlightRules;
    };
    oop.inherits(Mode, LiquidMode); // ACE's way of doing inheritance
    exports.Mode = Mode; // eslint-disable-line no-param-reassign
  }
);

// This is where we really create the highlighting rules
ace.define(
  "ace/mode/volcanicLiquid_highlight_rules",
  ["require", "exports", "ace/lib/oop", "ace/mode/liquid_highlight_rules"],
  (acequire, exports) => {
    const oop = acequire("ace/lib/oop");
    const LiquidHighlightRules = acequire("ace/mode/liquid_highlight_rules").LiquidHighlightRules;

    const CustomHighlightRules = function CustomHighlightRules() {
      LiquidHighlightRules.call(this);
      const functions =
        "date|capitalize|downcase|upcase|first|last|join|sort|map|size|escape|" +
        "escape_once|strip_html|strip_newlines|newline_to_br|replace|replace_first|" +
        "truncate|truncatewords|prepend|append|minus|plus|times|divided_by|split|default|asset_url|javascript_tag";

      const keywords =
        // Standard Tags
        "capture|endcapture|case|endcase|when|comment|endcomment|" +
        "cycle|for|endfor|in|reversed|if|endif|else|elsif|include|tephra|lava|lava_img|reset_assigns|endinclude|unless|endunless|" +
        // Commonly used tags
        "style|text|image|widget|plugin|marker|endmarker|tablerow|endtablerow|platform_js|google_maps_api_script";

      // common standard block tags that require to be closed with an end[block] token
      const blocks = "for|if|case|capture|unless|tablerow|marker|comment";

      const builtinVariables = "forloop|tablerowloop";
      // "forloop\\.(length|index|index0|rindex|rindex0|first|last)|limit|offset|range" +
      // "tablerowloop\\.(length|index|index0|rindex|rindex0|first|last|col|col0|"+
      // "col_first|col_last)"

      const definitions = "assign|var|variable";

      const keywordMapper = this.createKeywordMapper(
        {
          "variable.language": builtinVariables,
          keyword: keywords,
          "keyword.block": blocks,
          "support.function": functions,
          "keyword.definition": definitions
        },
        "identifier"
      );
      const currentrules = new LiquidHighlightRules().getRules();
      for (let rule in this.$rules) {
        if (this.$rules[rule]) {
          this.$rules[rule].unshift(
            {
              token: "variable",
              regex: "{%",
              push: "liquid-start"
            },
            {
              token: "variable",
              regex: "{{",
              push: "liquid-start"
            }
          );
        }
      }
      this.addRules({
        ...currentrules,
        "liquid-start": [
          ...currentrules["liquid-start"].filter(
            ({ regex }) => !regex.toString().includes("[a-zA-Z_$][a-zA-Z0-9_$]*\\b")
          ),
          {
            token: keywordMapper,
            regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
          }
        ]
      });
      this.normalizeRules();
    };

    oop.inherits(CustomHighlightRules, LiquidHighlightRules);
    exports.CustomHighlightRules = CustomHighlightRules;
  }
);

ace.define("ace/mode/example", function(require, exports) {
  let oop = require("ace/lib/oop");
  let TextMode = require("ace/mode/text").Mode;
  let ExampleHighlightRules = require("ace/mode/example_highlight_rules").ExampleHighlightRules;

  let Mode = function() {
    this.HighlightRules = ExampleHighlightRules;
  };
  oop.inherits(Mode, TextMode);
  (function() {
    // Extra logic goes here. (see below)
  }.call(Mode.prototype));

  exports.Mode = Mode;
});

ace.define("ace/mode/example_highlight_rules", function(require, exports) {
  let oop = require("ace/lib/oop");
  let TextHighlightRules = require("ace/mode/text_highlight_rules").TextHighlightRules;

  let ExampleHighlightRules = function() {
    this.$rules = new TextHighlightRules().getRules();
  };

  oop.inherits(ExampleHighlightRules, TextHighlightRules);

  exports.ExampleHighlightRules = ExampleHighlightRules;
});
